import dayjs from "dayjs";

export const getAssistantsString = (pax) => {
    return pax
        .filter(passenger => passenger.value > 0) // Ignorar si el value es 0
        .map(passenger => `${passenger.value} ${passenger.title}${passenger.value > 1 ? 's' : ''}`) // Formatear texto
        .join(', '); // Unir con comas
}

export const getTotalAssistants = (pax) => {
    return pax.reduce((accumulator, currentValue) => accumulator + currentValue.total, 0);
}



export const prePrareTourBookingData = (tour, date, items, extras, options = {}) => {
    const getCoverOrDefault = (array, condition) => {
        return array?.find(condition) || array[0] || null;
    };
    const condition = image => image.isCover;
    let cover = getCoverOrDefault(tour.images, condition);

    // console.log('cover', items);

    // Prefer selectedAttractions provided in options for pricing and extras; fallback to extras.activities
    const activitiesSource = Array.isArray(options?.selectedAttractions) && options.selectedAttractions.length > 0
        ? options.selectedAttractions
        : (extras?.activities || []);

    const totalPrice = items.reduce((total, item) => {
        // Suma el precio de cada item
        let itemTotal = item.price * item.value;

        // Suma el precio de activitiesSource rates solo si item.title está en rate.pax
        if (activitiesSource && activitiesSource.length > 0) {
            activitiesSource.forEach(activity => {
                activity?.rates?.forEach(rate => {
                    if (rate.pax && rate.pax.includes(item.title)) {
                        itemTotal += rate.price * item.value;
                    }
                });
            });
        }

        return total + itemTotal;
    }, 0);

    const languages = options.languages ?? tour?.languages ?? [];
    const details = tour?.tourDetails ?? tour;

    const tourtoBook = {
        name: tour.name,
        slug: tour.slug,
        city: tour.city.slug,
        country: tour.country.slug,
        cover: cover?.imagen || cover, // keep previous behavior but safer
        // explicit items + legacy `booking` kept for compatibility
        items: items,
        options: options,
        extras: {
            activities: activitiesSource,
            attractions: activitiesSource,
            extras: activitiesSource,
        },
        // include the full tour details and a `details` alias
        tourDetails: details,
        details: details,
        // include languages (from options param or tour)
        languages: languages,
        date: dayjs(date).format('YYYY-MM-DD'),
        booking: items,
        total: totalPrice,
        iva: tour.iva,
    }

    // If caller provided selected companion / languages in options, surface them
    // both under `customizations` (preferred) and as small convenience top-level fields
    const customizations = tourtoBook.customizations || {};

    if (options?.selectedCompanion) {
        customizations.travelCompanion = options.selectedCompanion;
        tourtoBook.travelCompanion = options.selectedCompanion;
    }

    if (options?.languages && Array.isArray(options.languages) && options.languages.length > 0) {
        customizations.language = options.languages[0];
        tourtoBook.language = options.languages[0];
    }

    if (options?.selectedGuide) {
        customizations.guide = options.selectedGuide;
        tourtoBook.guide = options.selectedGuide;
    }

    // include selected vehicle if provided
    if (options?.selectedVehicle) {
        // ensure we surface the vehicle object (including vehicle_option.value when present)
        customizations.vehicle = options.selectedVehicle;
        tourtoBook.vehicle = options.selectedVehicle;
    }

    // include selected attractions if provided (array of attraction names or objects)
    if (options?.selectedAttractions) {
        customizations.attractions = options.selectedAttractions;
        tourtoBook.attractions = options.selectedAttractions;
    }

    if (Object.keys(customizations).length > 0) {
        tourtoBook.customizations = customizations;
    }

    return tourtoBook

}